// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__U6Kc4","box":"WorkspacesBox_box__2YDss","node":"WorkspacesBox_node__1ZXw7"};